import { lazy } from 'react';

export const VerifyEmail = lazy(() => import('./VerifyEmail.component'));
